import "./navigation";
//import "./form-validation";

document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth >= 1440) {
        let imageStatic = document.querySelector(".services__right .services__image img");
        if (imageStatic) {
            const imageStaticSrc = imageStatic.dataset.src;
            console.log(imageStaticSrc);
            let hoverItems = document.querySelectorAll(".services__items .services__item");
            
            hoverItems.forEach(item => {
                item.addEventListener('mouseenter', e => {
                    imageStatic.src = item.dataset.src;
                });
            });
    
            hoverItems.forEach(item => {
                item.addEventListener('mouseleave', e => {
                    imageStatic.src = imageStaticSrc;
                });
            });
        }
    }
});
// popup
{
    let modal = document.getElementById("popup-1");
    let span = document.getElementsByClassName("close-1")[0];
    let btn = document.getElementsByClassName("open-popup-1");
    let btnHeader = document.getElementsByClassName("modal");

    [].forEach.call(btn, (elem) => {
        elem.onclick = function () {
            modal.classList.toggle("active");
            document.body.classList.toggle('hidden');
        }
    });

    [].forEach.call(btnHeader, (item) => {
        item.onclick = function () {
            modal.classList.toggle("active");
            document.body.classList.toggle('hidden');
        }
    });

    if (span) {
        span.onclick = function () {
            modal.classList.toggle("active");
            document.body.classList.toggle('hidden');
        }
    }

    window.onclick = function (event) {
        if (event.target == modal) {
            modal.classList.toggle("active");
            document.body.classList.toggle('hidden');
        }
    }
}

// submenu
{

    let carrets = document.querySelectorAll('.menu-item-has-children');
    [].forEach.call(carrets, function (addCarrets) {
        addCarrets.innerHTML += '<svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 1L4 4M4 4L4.14286 3.85714M4 4L1 1" stroke-width="2" stroke-linecap="round"/></svg>';
    });
}


// tabs
if (document.querySelector('#about-tabs') && document.querySelector('#about-tabs-thumbnail')) {
    const aboutTabs = new Splide('#about-tabs', {
        type: 'fade',
        pagination: false,
        arrows: false,
        perPage: 1,
        drag: false,
    });

    const aboutTabsThumbnails = new Splide('#about-tabs-thumbnail', {
        autoWidth: true,
        isNavigation: true,
        pagination: false,
        arrows: false,
        drag: false,
        dragMinThreshold: {
            mouse: 4,
            touch: 10,
        },
    });

    aboutTabs.sync(aboutTabsThumbnails);
    aboutTabs.mount();
    aboutTabsThumbnails.mount();
}
if (document.querySelector('#fleet-tabs') && document.querySelector('#fleet-tabs-thumbnail')) {
    const fleetTabs = new Splide('#fleet-tabs', {
        type: 'fade',
        pagination: false,
        arrows: false,
        perPage: 1,
        drag: false,
    });

    const fleetTabsThumbnails = new Splide('#fleet-tabs-thumbnail', {
        autoWidth: true,
        isNavigation: true,
        pagination: false,
        arrows: false,
        drag: false,
        dragMinThreshold: {
            mouse: 4,
            touch: 10,
        },
    });

    fleetTabs.sync(fleetTabsThumbnails);
    fleetTabs.mount();
    fleetTabsThumbnails.mount();
}

// sliders
if (document.querySelector('#gallery-slider')) {
    document.addEventListener('DOMContentLoaded', function () {
        const gallerySlider = new Splide('#gallery-slider', {
            pagination: true,
            arrows: true,
            drag: true,
        });
        gallerySlider.mount();
    });
}
if (document.querySelector('#gallery-slider-2') && document.querySelector('#gallery-slider-thumbnail-2')) {
    document.addEventListener('DOMContentLoaded', function () {
        const gallerySlider2 = new Splide('#gallery-slider-2', {
            pagination: false,
            arrows: false,
        });

        const gallerySliderThumbnails2 = new Splide('#gallery-slider-thumbnail-2', {
            pagination: false,
            isNavigation: true,
            drag: true,
        });

        gallerySlider2.sync(gallerySliderThumbnails2);
        gallerySlider2.mount();
        gallerySliderThumbnails2.mount();
    });
}

let element1 = document.querySelector('input.close[type="radio"]');
let element2 = document.querySelector('input.open[type="radio"]');
element1.addEventListener('change', (e) => {
    document.body.classList.remove('overflow');
})
element2.addEventListener('change', (e) => {
    document.body.classList.add('overflow');
})

// header

$(window).scroll(function (e) {
    if ($(window).scrollTop() > 0) {
        $('.header__top').addClass("shadow");
    } else {
        $('.header__top').removeClass("shadow");
    }
});

//Popup


jQuery("img:not([title])").each(function() {
    if(jQuery(this).attr("alt") !== '') jQuery(this).attr("title", jQuery(this).attr("alt"));
});

jQuery("img:not([alt])").each(function() {
    if(jQuery(this).attr("title") !== '') jQuery(this).attr("alt", jQuery(this).attr("title"));
});

const pageUrls = document.querySelectorAll(".current_page_item a");

if (pageUrls.length) {
  pageUrls.forEach((item) => {
    if (!item.href.includes("#")){
        item.removeAttribute("href");
        item.setAttribute("href", "#");
    } 
  });
}

const LogoUrls = document.querySelectorAll( '.header__logo a' );

if ( LogoUrls.length ) {
	LogoUrls.forEach( ( item ) => {
		if ( window.location.href === item.href) {
			item.removeAttribute( 'href' );
			item.setAttribute( 'href', '#' );
		}
	} );
}
jQuery(document).ready(function($) {
    $(".wpcf7").on('submit.wpcf', function(){
    if ($(".ajax-loader").hasClass("is-active"))
    {
    $('input[type=”submit”]').attr('disabled', 'disabled');
    setTimeout(function() {
    $('input[type="submit"]').removeAttr('disabled');
    },3000);
    }
    });
}); 

document.addEventListener('DOMContentLoaded', function () {
    var closeButtons = document.querySelectorAll('.thanks-icon-close');
    closeButtons.forEach(function (closeButton) {
        closeButton.addEventListener('click', function () {
            var popup = closeButton.closest('.thanks_popup');
            if (popup) {
                popup.classList.remove('active');
            }
        });
    });
});